import styled from 'styled-components';

import { SortBy, SortOrder } from '../../../types/api';
import useStore from '../../../store';

import Icon from '../../../components/Icon';
import Text from '../../../components/Text';

import { color, space } from '../../../stylesheets';

const StyledSortButton = styled.button`
  display: flex;
  text-align: left;
  align-items: center;
  margin-bottom: 3px;
  background: ${color('neutral', 10)};
  transition: all 0.2s ease-in-out;

  svg {
    margin-left: ${space('xxs')};
    color: ${color('primary', 10)};
  }

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 3px;
  }

  &:hover svg {
    transition: all 0.2s ease-in-out;
    color: ${color('primary', 50)};
  }
`;

type SortButtonProps = { id: SortBy; label: string; ariaLabel?: string };

const SortButton = ({ id, label, ariaLabel }: SortButtonProps) => {
  const sortBy = useStore(state => state.search.sortBy);
  const sortOrder = useStore(state => state.search.sortOrder);
  const updateSortBy = useStore(state => state.search.updateSortBy);

  return (
    <StyledSortButton
      type="button"
      onClick={() => updateSortBy(id)}
      aria-label={ariaLabel}
      aria-sort={
        sortBy === id ? (sortOrder === SortOrder.ASC ? 'ascending' : 'descending') : undefined
      }
    >
      <Text variant="form-label" as="span">
        {label}
      </Text>

      {sortBy === id && (
        <Icon size="supertiny" icon={sortOrder === SortOrder.ASC ? 'Upward' : 'Downward'} />
      )}
    </StyledSortButton>
  );
};

export default SortButton;
